import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, Content} from 'ionic-angular';
import { PhonebookProfilePage } from '../phonebook-profile/phonebook-profile';

import { UserProvider } from '../../providers/user';
import { TeamappProvider } from '../../providers/teamapp';
/**
 * Generated class for the PhonebookPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-phonebook',
  templateUrl: 'phonebook.html',
})
export class PhonebookPage {
  title: string = 'Kontakte';

  @ViewChild(Content) content: Content;

  searchQuery: string = '';
  contacts: any;
  contactsAll: any;
  contactsFiltered: any = [];

  constructor(public navCtrl: NavController, public navParams: NavParams, public userProvider: UserProvider, public teamappProvider: TeamappProvider) {
      if(this.navParams.get("title")) {
          this.title = this.navParams.get("title");
      }
      this.initializeItems();
  }


  ionViewDidLoad() {
    console.log('ionViewDidLoad PhonebookPage');
  }

  initializeItems() {
      this.teamappProvider.http_request('', 'phonebook', false, true).then(data => {
          this.contacts = data;
          console.log(this.contacts);
          this.contactsAll = data;
      });
  }

  onClickContact(item: any) {
      this.navCtrl.push(PhonebookProfilePage,
          {
            name: item.name,
            surname: item.surname,
            image: item.image,
            phone: item.number,
            mobile: item.mobile,
            mail: item.email,
            company: item.company,
            company_details: item.company_details,
            branche: item.category,
            position: item.position,
            chat_key: item.chatkey,
            title: this.title
          }
      );
  }
  onLetterChoose(data:any) {
      console.log("EMIT: "+data.name)
      this.scrollTo(data.name);
  }

  scrollTo(element:string) {
    let elem = document.getElementById(element);
    if(elem !== null) {
        var box = elem.getBoundingClientRect();

        var body = document.body;
        var docEl = document.documentElement;

        var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
        var clientTop = docEl.clientTop || body.clientTop || 0;
        var top = box.top + scrollTop; - clientTop;
        var cDim = this.content.getContentDimensions();

        var scrollOffset = Math.round(top) + cDim.scrollTop - cDim.contentTop;
        console.log(scrollOffset);
        this.content.scrollTo(0, scrollOffset, 500);
    }
  }


  filterItems(ev: any) {

    this.contacts = this.contactsAll;
    this.contactsFiltered = [];
    const val = ev.target.value;
    if (val && val.trim() != '') {
        this.searchQuery = val;
        this.contacts.filter((item) => {
            item.member.filter((members) => {
                if((members.name.toLowerCase().indexOf(val.toLowerCase()) > -1) || (members.surname.toLowerCase().indexOf(val.toLowerCase()) > -1) || (members.company && members.company.toLowerCase().indexOf(val.toLowerCase()) > -1)) {
                    this.contactsFiltered.push(members);
                }
            })

        })
        console.log(this.contactsFiltered);
    } else {
        this.searchQuery = '';
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/phonebook/phonebook.ts